import WatchlistPortfolioCard from './WatchlistPortfolioCard.component';

export default WatchlistPortfolioCard;
